<template>
  <div class="membership-benefits-list">
    <MembershipBenefitsListItem
      v-for="({ iconUrl, benefitText }, i) in benefits"
      :key="`benefits-list-item_${i}`"
      :icon-url="iconUrl"
      :text="benefitText"
      class="membership-benefits-list__item"
    />
  </div>
</template>

<script>
import MembershipBenefitsListItem from "./MembershipBenefitsListItem.vue"

export default {
  components: {
    MembershipBenefitsListItem,
  },
  props: {
    benefits: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.membership-benefits-list {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/store/subscription/benefits-panel/TheMembershipBenefitsList.vue